import React from "react"

import New from "./New"
import Table from "./Table"

const TutorApplicationsIndex = () => {
  return (
    <>
      <New />
      <Table />
    </>
  )
}

export default TutorApplicationsIndex
